<template>
  <section
    class="d-flex flex-column py-12"
    :style="
    `
      min-height: ${settings.bg && settings.bg.height ? settings.bg.height : 300}px;
      background-image: url(${MIXIN_getBgInfo(settings, 'image')});
      background-color: ${MIXIN_getBgInfo(settings, 'color')};
      background-position: center;
      background-size: cover;
    `
    "
  >
    <div class="d-flex flex align-center justify-center">
      <div class="d-flex flex px-12 py-6" style="max-width: 1340px; height: 100%">
        <v-row no-gutters>
          <!-- Organizadores  -->
          <v-col 
            :cols="$vuetify.breakpoint.mdAndUp ? '6' : '12'"
            :class="[{'pr-3': $vuetify.breakpoint.mdAndUp}]"
          >
            <h3
              v-if="settings.organization.title" 
              :class="[{'text-center': !$vuetify.breakpoint.mdAndUp}]"
              :style="
                `
                font-size: ${MIXIN_getStyle(settings, 'subtitle', 'font-size')} !important;
                font-family: ${MIXIN_getStyle(settings, 'subtitle', 'font')} !important;
                color: ${MIXIN_getStyle(settings, 'subtitle', 'color')} !important; 
                line-height: ${MIXIN_getStyle(settings, 'subtitle', 'font-size')} !important; 
                font-weight: ${MIXIN_getStyle(settings, 'subtitle', 'weight')} !important;
                font-style: ${MIXIN_getStyle(settings, 'subtitle', 'font-style')} !important;
                `
              "              
            >
              {{ settings.organization.title }}
            </h3>

            <div 
              :class="['d-flex align-center', {'justify-center': !$vuetify.breakpoint.mdAndUp}]"
              style="flex-wrap: wrap; gap: 8px"
            >
              <div v-for="(image, i) in settings.organization.logos" :key="i">
                <v-img eager max-width="125" contain :src="image.image"></v-img>
              </div>
            </div>
          </v-col>

          <!-- Contato  -->
          <v-col 
            :cols="$vuetify.breakpoint.mdAndUp ? '3' : '12'"
            :class="[{'pr-3': $vuetify.breakpoint.mdAndUp}, {'pt-12': !$vuetify.breakpoint.mdAndUp}]"
          >
            <h3 
              :class="[{'text-center': !$vuetify.breakpoint.mdAndUp}]"
              :style="
                `
                font-size: ${MIXIN_getStyle(settings, 'subtitle', 'font-size')} !important;
                font-family: ${MIXIN_getStyle(settings, 'subtitle', 'font')} !important;
                color: ${MIXIN_getStyle(settings, 'subtitle', 'color')} !important; 
                line-height: ${MIXIN_getStyle(settings, 'subtitle', 'font-size')} !important; 
                font-weight: ${MIXIN_getStyle(settings, 'subtitle', 'weight')} !important;
                font-style: ${MIXIN_getStyle(settings, 'subtitle', 'font-style')} !important;
                `
              "              
            >
              {{ settings.contact.title }}
            </h3>

            <div 
              :class="['d-flex', {'justify-center': !$vuetify.breakpoint.mdAndUp}]"
              style="flex-wrap: wrap; gap: 8px"
            >
              <div>
                <span 
                  :style="
                    `
                    font-size: ${MIXIN_getStyle(settings, 'text', 'font-size')} !important;
                    font-family: ${MIXIN_getStyle(settings, 'text', 'font')} !important;
                    color: ${MIXIN_getStyle(settings, 'text', 'color')} !important; 
                    font-weight: ${MIXIN_getStyle(settings, 'text', 'weight')} !important;
                    font-style: ${MIXIN_getStyle(settings, 'text', 'font-style')} !important;
                    padding-bottom: 2px;
                    display: block;
                    `
                  "
                >
                  {{ settings.contact.phone }}
                </span>

                <span 
                  :style="
                    `
                    font-size: ${MIXIN_getStyle(settings, 'text', 'font-size')} !important;
                    font-family: ${MIXIN_getStyle(settings, 'text', 'font')} !important;
                    color: ${MIXIN_getStyle(settings, 'text', 'color')} !important; 
                    font-weight: ${MIXIN_getStyle(settings, 'text', 'weight')} !important;
                    font-style: ${MIXIN_getStyle(settings, 'text', 'font-style')} !important;
                    padding-bottom: 2px;
                    display: block;
                    `
                  "
                >
                  {{ settings.contact.email }}
                </span>

                <span 
                  :style="
                    `
                    font-size: ${MIXIN_getStyle(settings, 'text', 'font-size')} !important;
                    font-family: ${MIXIN_getStyle(settings, 'text', 'font')} !important;
                    color: ${MIXIN_getStyle(settings, 'text', 'color')} !important; 
                    font-weight: ${MIXIN_getStyle(settings, 'text', 'weight')} !important;
                    font-style: ${MIXIN_getStyle(settings, 'text', 'font-style')} !important;
                    display: block;
                    `
                  "
                >
                  {{ settings.contact.site }}
                </span>
              </div>
            </div>
          </v-col>

          <!-- Social  -->
          <v-col 
            :cols="$vuetify.breakpoint.mdAndUp ? '3' : '12'"
            :class="[{'pt-12': !$vuetify.breakpoint.mdAndUp}]"
          >
            <h1 
              :class="[{'text-center': !$vuetify.breakpoint.mdAndUp}]"
              :style="
                `
                font-size: ${MIXIN_getStyle(settings, 'subtitle', 'font-size')} !important;
                font-family: ${MIXIN_getStyle(settings, 'subtitle', 'font')} !important;
                color: ${MIXIN_getStyle(settings, 'subtitle', 'color')} !important; 
                line-height: ${MIXIN_getStyle(settings, 'subtitle', 'font-size')} !important; 
                font-weight: ${MIXIN_getStyle(settings, 'subtitle', 'weight')} !important;
                font-style: ${MIXIN_getStyle(settings, 'subtitle', 'font-style')} !important;
                `
              "              
            >
              {{ settings.social.title }}
            </h1>

            <div 
              :class="['d-flex align-center pt-3', {'justify-center': !$vuetify.breakpoint.mdAndUp}]"
              style="flex-wrap: wrap; gap: 20px"
            >
            <a
              v-if="settings.social.facebook"
              :href="handleHref(settings.social.facebook, 'face')"
              target="_blank"
            >
              <v-icon class="pointer" :color="settings['item-color']" size="22">
                fa-brands fa-facebook-f
              </v-icon>
            </a>

            <a
              v-if="settings.social.instagram"
              target="_blank"
              :href="handleHref(settings.social.instagram, 'insta')"
            >
              <v-icon class="pointer" :color="settings['item-color']">
                fa-brands fa-instagram
              </v-icon>
            </a>

            <a
              v-if="settings.social.youtube"
              target="_blank"
              :href="handleHref(settings.social.youtube, 'youtube')"
            >
              <v-icon class="pointer" :color="settings['item-color']">
                fa-brands fa-youtube
              </v-icon>
            </a>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </section>
</template>

<script>
import {GetLayoutSectionMixin} from "../../mixins/GetLayoutSection"

export default {
  mixins: [GetLayoutSectionMixin],  
  props: {
    settings: { type: Object }
  },

  data() {
    return {
      hover: false,
    };
  },

  methods: {
    handleHref(item, type) {
      if (type === "face") return `https://www.facebook.com/${item}/`;
      if (type === "insta") return `https://www.instagram.com/${item}/`;
      else return `https://www.youtube.com/${item}/`;
    },
  }
};
</script>

<style scoped>
h3 {
  font-size: 16px;
  font-style: normal;
  padding-bottom: 12px;
}

a {
  border: none;
  text-decoration: none;
}

span {
  font-size: 12px;
}
</style>
